import React from 'react';
import moment from 'moment';
import { main_activities } from '../../Commercial/utils';
import InputByTypeBackoffice from './parts/InputByTypeBackoffice';

function BackOfficeCommercialCompanyStep({
  errors,
  isValid,
  register,
  setValue,
  control,
  formData,
  isModifyState,
}) {
  const vatNumberInput = {
    name: 'vat_number',
    label: 'Partita IVA',
    placeholder: '-Partita IVA-',
    type: 'text',
    className: 'col-12 col-md-12',
  };

  const stepInputs = [
    {
      name: 'attpr_value',
      label: 'Attività Principale',
      placeholder: '-Attività Principale-',
      type: 'select',
      options: main_activities,
      className: 'col-12 col-md-12',
      searchable: true,
    },
    {
      name: 'turnover_value',
      label: 'Valore del Fatturato',
      placeholder: '-Valore del Fatturato-',
      type: 'price',
      className: 'col-12 col-md-12',
    },
    {
      name: 'number_of_employees',
      label: 'Numero di Dipendenti',
      placeholder: '-Numero di Dipendenti-',
      type: 'text',
      className: 'col-12 col-md-12',
    },
    {
      name: 'effective_date',
      label: 'Data di Decorrenza',
      type: 'date',
      minDate: moment().format('YYYY-MM-DD'),
      className: 'col-12 col-md-12',
    },
    {
      name: 'address',
      label: "Cerca l'indirizzo (comune se necessario)",
      placeholder: '--',
      type: 'address',
      className: 'col-12 col-md-12',
    },
  ];

  return (
    <div className="row mt-4">
      <div className={vatNumberInput.className} key={vatNumberInput.name}>
        <InputByTypeBackoffice
          input={vatNumberInput}
          register={register}
          errors={errors}
          isValid={isValid}
          setValue={setValue}
          control={control}
          isModifyState={isModifyState}
        />
      </div>

      {stepInputs.map((input) => (
        <div className={input.className} key={input.name}>
          <InputByTypeBackoffice
            input={input}
            register={register}
            errors={errors}
            isValid={isValid}
            setValue={setValue}
            control={control}
            formData={formData}
            isModifyState={isModifyState}
          />
        </div>
      ))}
    </div>
  );
}

export default BackOfficeCommercialCompanyStep;
